import { render } from "./IncidentReport.vue?vue&type=template&id=2ca7bbd2&scoped=true"
import script from "./IncidentReport.vue?vue&type=script&lang=js"
export * from "./IncidentReport.vue?vue&type=script&lang=js"

import "./IncidentReport.vue?vue&type=style&index=0&id=2ca7bbd2&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca7bbd2"]])

export default __exports__